import React from 'react';

// Routing
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { EXPERT_CHECKOUT, IRoute, REGISTER_AS_EXPERT3_ROUTE, routes, EVENTPOST_ROUTE } from './AppRoutes';
import { PrivateRoute } from './PrivateRoute';
import { RouteSuspense } from './RouteSuspense';
import { userRoutes } from './AccountRoutes';
import ScrollToTop from './ScrollToTop';

// UI
import { ContactUsFooter } from '../features/ContactUsFooter/ContactUsFooter';
import { HeaderLayout } from '../components/layouts/HeaderLayout/HeaderLayout';
import { UserLayout } from '../components/layouts/UserLayout/UserLayout';
import { NewsBlock } from 'src/pages/newsBlock/NewsBlock';
import { BlogPost } from '../pages/blogPost/BlogPost';
import { AllPosts } from '../pages/allposts/AllPosts';
import { EventsNew } from '../pages/eventsnew/EventsNew';
import { EventPost } from 'src/pages/eventsnew/EventPost';
import { Beginnersguide } from 'src/pages/guideLines/Beginnersguide';
import { Doctorpackage } from '../pages/landing/doctor/Doctorpackage';
import { Authorpackage } from '../pages/landing/author/Authorpackage';
import { AuthorNews } from "src/pages/newsBlock/author/AuthorNews";
import { JournalistLandingPage } from '../pages/landing/journalist/JournalistLandingPage';

const getUserRoutesPath = (routesList: Array<IRoute>): Array<string> => {
  const paths: Array<string> = [];

  routesList.forEach((route) => {
    if (route.routes) {
      paths.push(route.path, ...getUserRoutesPath(route.routes));
    } else paths.push(route.path);
  });

  return paths;
};

const FooterLayout: React.FC<any> = (props) => {
  const { children } = props;
  return (
    <>
      {children}
      <ContactUsFooter style={{ marginTop: 'auto' }} />
    </>
  );
};

const userCabinetPaths = getUserRoutesPath(userRoutes);

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <HeaderLayout>
        <ScrollToTop />
        <Switch>
          <Route path={userCabinetPaths} exact>
            <UserLayout />
          </Route>
          {/* <Route
            exact
            path={[
              REGISTER_AS_EXPERT2_ROUTE.path,
              ...routes.map((route) => route.path),
            ]}> */}
            <FooterLayout>
              <Switch>
			    {/* <PrivateRoute exact {...EVENTSNEW_ROUTE} /> */}
                <Route path="/news/:id">
                  <NewsBlock />
                </Route>
                <Route path="/blogpost/:id">
                  <BlogPost />
                </Route>
                <Route path="/allposts">
                  <AllPosts />
                </Route>
                <PrivateRoute {...EXPERT_CHECKOUT} />
				<PrivateRoute exact {...EVENTPOST_ROUTE} />
				
                {/* <Route path="/news-diary/:id">
					<EventPost />
				</Route> */}
                <Route path="/author/:name/:id">
                  <AuthorNews />
                </Route>
                <Route path="/build-your-media-profile">
                  <Beginnersguide />
                </Route>
				<Route path="/doctor">
                  <Doctorpackage />
                </Route> 
				<Route path="/author">
                  <Authorpackage />
                </Route>
				<Route path="/journalist">
                  <JournalistLandingPage />
                </Route>
                <PrivateRoute {...REGISTER_AS_EXPERT3_ROUTE} />
                {routes.map((route) => {
                  return (
                    <Route exact key={route.path} path={route.path}>
                      <RouteSuspense>
                        <route.component />
                      </RouteSuspense>
                    </Route>
                  );
                })}
              </Switch>
            </FooterLayout>
          {/* </Route> */}
        </Switch>
      </HeaderLayout>
    </BrowserRouter>
  );
};
